module.exports = __webpack_public_path__ + "img/2.3_Associate-Investigators_7_Dobbins.ba28e0b74658b27f20f5f153ed6ae3f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.3_Associate-Investigators_7_Dobbins.jpg
// module id = 762
// module chunks = 0